import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const updateFirmwareAction = getApiActionCreator(actionTypes.UPDATE_FIRMWARE_SETTINGS);

export const updateFirmware = (gatewayID) => {
    return {
        type: actionTypes.UPDATE_FIRMWARE,
        gatewayID
    };
};

export const clearStore = () => {
    return {
        type: actionTypes.CLEAR_STORE
    };
};
